import ListaSistemaAguaGelada from "./ListaSistemasAguaGelada";
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
export default function SistemaAguaGelaForm({ styles }) {

    return (
        <AlertDialogOnClose nome={"Sistema de Água Gelada"} placeholder={"Insira o nome do sistema"}>
            <ListaSistemaAguaGelada/>
        </AlertDialogOnClose>
    )
} 